import * as React from 'react'

import type { GetCurrentQuery } from 'generated/resources/graphql'

import { SessionContext } from 'modules/core/components/SessionProvider'

export type Access =
  GetCurrentQuery['apiCore']['currentsConnection']['edges'][number]['node']['access']
export type Employee =
  GetCurrentQuery['apiCore']['currentsConnection']['edges'][number]['node']['employee']
export type Company =
  GetCurrentQuery['apiCore']['currentsConnection']['edges'][number]['node']['company']
export type Subscription =
  GetCurrentQuery['apiCore']['currentsConnection']['edges'][number]['node']['company']['subscription']

export const useCurrentSession = () => {
  const session = React.useContext(SessionContext)

  if (!session) {
    throw new Error('Trying to retrieve session information before fetch it')
  }

  return session
}
